import { render, staticRenderFns } from "./Scaffold.vue?vue&type=template&id=57e4ff9a&scoped=true"
import script from "./Scaffold.vue?vue&type=script&lang=js"
export * from "./Scaffold.vue?vue&type=script&lang=js"
import style0 from "./Scaffold.vue?vue&type=style&index=0&id=57e4ff9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e4ff9a",
  null
  
)

export default component.exports